import { useLocation } from 'react-router-dom'

import { F0Button } from '@factorialco/f0-react'
import { Check } from '@factorialco/f0-react/icons/app'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { SkeletonValue } from 'modules/finance/components/FinancialWorkspace/components/SkeletonValue'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

interface UpsellingButtonProps {
  moduleRequested: AvailableModules
  requestSource: string
  pageSource?: string
  reason?: ValidReasons
  featureRequested?: Features
  buttonTexts: {
    requested: string
    unlock: string
  }
}

export const UpsellButton = ({
  moduleRequested,
  requestSource,
  featureRequested,
  reason = ValidReasons.MissingFeature,
  pageSource,
  buttonTexts,
}: UpsellingButtonProps) => {
  const location = useLocation()

  const [moduleAlreadyRequested, setModuleAlreadyRequested] = useLocalStorage<boolean>(
    `factorial:fw:${moduleRequested}Requested`,
    false
  )

  const FallbackButton = () => (
    <F0Button variant="promote" disabled icon={Check} label={buttonTexts.requested} />
  )

  if (moduleAlreadyRequested) {
    return <FallbackButton />
  }

  return (
    <UpsellingKit.UpsellButton
      moduleRequested={moduleRequested}
      requestSource={requestSource}
      featureRequested={featureRequested}
      pageSource={pageSource || location.pathname}
      requestReason={reason}
      showModuleModal
      label={buttonTexts.unlock}
      loadingComponent={<SkeletonValue height="s20" />}
      fallbackComponent={<FallbackButton />}
      onRequest={() => setModuleAlreadyRequested(true)}
      variant="outlinePromote"
    />
  )
}
